import { render, staticRenderFns } from "./UserEkspedisi.vue?vue&type=template&id=04d92272&scoped=true&"
import script from "./UserEkspedisi.vue?vue&type=script&lang=js&"
export * from "./UserEkspedisi.vue?vue&type=script&lang=js&"
import style0 from "./UserEkspedisi.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UserEkspedisi.vue?vue&type=style&index=1&id=04d92272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d92272",
  null
  
)

export default component.exports